// extracted by mini-css-extract-plugin
export default {"root":"Privacy_root__CdbCh"};